import { render, staticRenderFns } from "./VaSeparator.vue?vue&type=template&id=f1793386&"
import script from "./VaSeparator.vue?vue&type=script&lang=js&"
export * from "./VaSeparator.vue?vue&type=script&lang=js&"
import style0 from "./VaSeparator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports